import { LOGIN_URL, RESET_PASS_URL, FORGOT_PASS_URL, CHANGE_PASS_URL } from "../constants"
import { APP_LINKS, ROLE_FLAGS } from "../../../router/navlinks"
export const SESSION_KEYS = {
    USER_SESSION: "tma_user_session",
    SESSION_ROLES: "tma_session_roles",
};

const getJSONHeaders = () => {
    return new Headers({
        "content-type": "application/json"
    })
}
export const getAuthHeadersForFormData = () => {
    const { token } = getLoggedInUserInfo() || {};
    return new Headers({
        "authorization": `Bearer ${token}`
    });
};
export const getAuthHeaders = () => {
    const { token } = getLoggedInUserInfo() || {};
    return new Headers({
        "content-type": "application/json",
        "authorization": `Bearer ${token}`
    })
}
const getPageMappings = (details) => {
    const roleKeysFromResponse = Object.keys(details);
    const flags = ROLE_FLAGS.filter(role => roleKeysFromResponse.includes(role));
    const validRoutes = APP_LINKS.filter(link => {
        if (!link.requiresAuth || link.isCommonRoute) return true;
        return flags.some(flag => link[flag] === details[flag]);
    }).map(link => {
        return {
            ...link,
            path: link.path === "*" ? "/404" : link.path
        }
    });
    return validRoutes;
};
export const saveSessionToLocal = (sessionInfo) => {
    sessionStorage.setItem(SESSION_KEYS.USER_SESSION, JSON.stringify(sessionInfo));
}
export const saveloginInfoToLocal = (loginInfo) => {
    if (!loginInfo || !loginInfo.Token || !loginInfo.UserDetails) {
        throw new Error("Invalid loginInfo structure");
    }
    const { Token, UserDetails } = loginInfo;
    const userInfo = {};
    for (let key in UserDetails) {
        if (!ROLE_FLAGS.includes(key)) {
            userInfo[key] = UserDetails[key];
        }
    }
    const accessiblePages = getPageMappings(UserDetails);
    const sessionInfo = {
        token: Token,
        userInfo: userInfo,
    }
    saveSessionToLocal(sessionInfo);
    sessionStorage.setItem(SESSION_KEYS.SESSION_ROLES, btoa(JSON.stringify(accessiblePages)));
}
export const getCurrentSessionPages = () => {
    try {
        const savedRoutes = sessionStorage.getItem(SESSION_KEYS.SESSION_ROLES);
        if (savedRoutes) {
            return JSON.parse(atob(savedRoutes));
        }
        throw new Error("Na saved pages found")
    }
    catch {
        return APP_LINKS.filter(link => link.isCommonRoute || !link.requiresAuth)
    }
}
export const clearCurrentSession = () => {
    sessionStorage.clear();
}
export const getLoggedInUserInfo = () => {
    const savedInfo = sessionStorage.getItem(SESSION_KEYS.USER_SESSION);
    if (savedInfo) {
        return JSON.parse(savedInfo);
    }
    return null;
}
export const getLoginServiceRequestDetails = (email, password) => {

    const payload = {
        Email: email,
        Password: password
    }
    const endpoint = LOGIN_URL;
    return {
        url: endpoint,
        options: {
            method: "POST",
            body: JSON.stringify(payload),
            headers: getJSONHeaders()
        }
    }
}

export const getResetPasswordServiceConfig = (payloadValues) => {
    const { email, password, secretPin } = payloadValues;
    const requestPayload = {
        Email: email,
        Password: password,
        Pin: secretPin
    }
    return {
        url: RESET_PASS_URL,
        options: {
            method: "POST",
            body: JSON.stringify(requestPayload),
            headers: getJSONHeaders()
        }
    }
}

export const getForgotPasswordRequestConfig = email => {
    const payload = {
        Email: email
    }
    return {
        url: FORGOT_PASS_URL,
        options: {
            method: "POST",
            body: JSON.stringify(payload),
            headers: getJSONHeaders()
        }

    }
}

export const getChangePasswordServiceConfig = (oldPass, newPass) => {
    const payload = {
        "CurrentPassword": oldPass,
        "NewPassword": newPass
    }
    return {
        url: CHANGE_PASS_URL,
        options: {
            method: "PUT",
            headers: getAuthHeaders(),
            body: JSON.stringify(payload)
        }
    }
}